// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"27b0e5cb","245":"4ffb2b2f","423":"304f7e69","432":"3978f8ee"}[chunkId] + ".chunk.js";
};